<template>
  <Box class="monetization__container">
    <Box class="monetization__content">
      <Glow class="monetization__glow" />
      <Box is-flex flex-direction="column" gap="4">
        <Box is-flex flex-direction="column" gap="1">
          <Heading size="h6" color="orange" letter-spacing="4" is-uppercase>{{ $t('pages.ssr_landing.monetization.subtitle') }}</Heading>
          <Heading class="monetization__title" color="purple-pink">{{ $t('pages.ssr_landing.monetization.title') }}</Heading>
        </Box>
        <CustomText size="large">{{ $t('pages.ssr_landing.monetization.description') }}</CustomText>
        <a :href="$locatedLink('/features/podcast-monetization/')">
          <Button class="link-button-arrow-animation" variant="transparent" size="medium" border-radius="large" has-border>
            <CustomText size="large" weight="bold">{{ $t('learn_more') }}</CustomText>
            <div class="link-button-arrow-animation__i">
              <SmallArrowIcon />
            </div>
          </Button>
        </a>
      </Box>

      <Box class="monetization__grid" mt="10">
        <Card
          class="monetization__top-card"
          :title="$t('pages.ssr_landing.monetization.cards.paid.title')"
          :description="$t('pages.ssr_landing.monetization.cards.paid.description')"
          src="/images/landing/monetization/paid.png"
          srcset="/images/landing/monetization/paid@2x.png 2x"
        />
        <Card
          class="monetization__top-card"
          :title="$t('pages.ssr_landing.monetization.cards.apple_podcasts.title')"
          :description="$t('pages.ssr_landing.monetization.cards.apple_podcasts.description')"
          src="/images/landing/monetization/apple-podcasts.png"
          srcset="/images/landing/monetization/apple-podcasts@2x.png 2x"
        />
        <Card
          class="monetization__bottom-card"
          :title="$t('pages.ssr_landing.monetization.cards.donation_button.title')"
          :description="$t('pages.ssr_landing.monetization.cards.donation_button.description')"
          src="/images/landing/monetization/donation-button.png"
          srcset="/images/landing/monetization/donation-button@2x.png 2x"
        />
        <Card
          class="monetization__bottom-card"
          :title="$t('pages.ssr_landing.monetization.cards.affiliate.title')"
          :description="$t('pages.ssr_landing.monetization.cards.affiliate.description')"
          src="/images/landing/monetization/affiliate.png"
          srcset="/images/landing/monetization/affiliate@2x.png 2x"
        />
        <Card
          class="monetization__bottom-card"
          :title="$t('pages.ssr_landing.monetization.cards.value_4_value.title')"
          :description="$t('pages.ssr_landing.monetization.cards.value_4_value.description')"
          src="/images/landing/monetization/value-4-value.png"
          srcset="/images/landing/monetization/value-4-value@2x.png 2x"
        />
      </Box>
    </Box>
  </Box>
</template>

<script>
import Glow from './svg/Glow'
import Card from './Card.vue'
import Box from '@/components/common/Box/Box'
import Heading from '@/components/common/Heading/Heading'
import CustomText from '@/components/common/CustomText/CustomText'
import Button from '@/components/common/Button/Button'

import SmallArrowIcon from '@/components/icons/default/ArrowSmall'

export default {
  components: {
    Glow,
    Box,
    Heading,
    CustomText,
    Button,
    Card,
    SmallArrowIcon
  }
}
</script>

<style lang="scss" scoped>
.monetization {
  &__container {

    padding: $gap * 4.5 $gap;
  }

  &__content {
    position: relative;
    max-width: 1200px;
    margin: 0 auto;
  }

  &__glow {
    position: absolute;
    width: 482px;
    height: 482px;
    top: 650px;
    left: -100px;
    pointer-events: none;
  }

  &__title {
    @include display-less(tablet) {
     font-size: 32px;
     line-height: 120%;
    }
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    grid-template-rows: auto auto;
    gap: $gap * 1.5;
  }

  &__top-card {
    grid-column: span 3;

    @include display-less(tablet) {
      grid-column: span 6;
    }
  }

  &__bottom-card {
    grid-column: span 2;

    @include display-less(tablet) {
      grid-column: span 6;
    }
  }
}
</style>
